<template>
    <div class='page'>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-s-promotion'
                        :loading='distributeLoading'
                        @click='handleDistribute'
                    >分发
                    </el-button>
                </div>
                <div class='icon-group'>
                    <span
                        class='icon-box'
                        title='刷新'
                        @click='refreshDetailsList'
                    >
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                max-height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <el-table-column align='center' prop='userName' label='用户名' min-width='120' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='userMobile' label='手机号' min-width='130'></el-table-column>
                <el-table-column align='center' prop='weekPeriod' label='考核周期' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='performance' label='业绩' min-width='100'></el-table-column>
                <el-table-column align='center' prop='rewardAmount' label='奖励金额' min-width='100'></el-table-column>
                <el-table-column align='center' prop='status' label='状态' width='100'>
                    <template slot-scope='scope'>
                        {{ statusLabel(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间' min-width='160'></el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getDetailsList(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getDetailsList(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { Refresh } from '@v2icons/tabler';
import { post, get } from '@/utils/request.js';

export default {
    name: 'WeeklyAssessment',
    components: {
        Refresh
    },
    data() {
        return {
            queryForm: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            distributeLoading: false,
            statusMenu: [
                { value: 0, label: '待分发' },
                { value: 1, label: '已分发' },
                { value: 2, label: '分发失败' }
            ]
        };
    },
    mounted() {
        this.getDetailsList();
    },
    methods: {
        statusLabel(status) {
            const item = this.statusMenu.find((s) => s.value === status);
            return item ? item.label : '--';
        },
        getDetailsList() {
            this.tableLoading = true;
            get(`/shop/admin/weekly-reward/details`, { ...this.queryForm }).then((res) => {
                this.tableLoading = false;
                if (res.success) {
                    this.tableData.list = res.pageInfo.list;
                    this.tableData.total = res.pageInfo.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        refreshDetailsList() {
            this.queryForm.pageNum = 1;
            this.getDetailsList();
        },
        handleDistribute() {
            this.$confirm('确定要分发周考核奖励吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.distributeLoading = true;
                post(`/shop/admin/weekly-reward/trigger`, {}).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg || '分发成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.getDetailsList();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                }).finally(() => {
                    this.distributeLoading = false;
                });
            }).catch((err) => {
                console.log("err======>", err);
            });
        }
    }
};
</script>

<style scoped></style>
